/**
 * @generated SignedSource<<68f3663927156d076fc22d8e424efb71>>
 * @relayHash 63854a4c84372d699a45f9c1a07dc352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e

import type { ConcreteRequest } from 'relay-runtime';
export type EditorUserPreferencesProviderQuery$variables = Record<PropertyKey, never>;
export type EditorUserPreferencesProviderQuery$data = {
  readonly userPreferences: {
    readonly confluenceEditorSettings: {
      readonly toolbarDockingInitialPosition: string | null;
    } | null;
  } | null;
};
export type EditorUserPreferencesProviderQuery = {
  response: EditorUserPreferencesProviderQuery$data;
  variables: EditorUserPreferencesProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceEditorSettings",
        "kind": "LinkedField",
        "name": "confluenceEditorSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "toolbarDockingInitialPosition"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EditorUserPreferencesProviderQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EditorUserPreferencesProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "63854a4c84372d699a45f9c1a07dc352",
    "id": "3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e",
    "metadata": {},
    "name": "EditorUserPreferencesProviderQuery",
    "operationKind": "query",
    "text": "query EditorUserPreferencesProviderQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
  }
};
})();

(node as any).hash = "22c44eb8a7e5e6240c1d402a68a09da0";

export default node;
